import * as React from 'react';
import clsx from 'clsx';

interface Props {
  className?: string;
  children: React.ReactNode;
}
/**
 * @deprecated Use ui/DialogTitle with ui/Dialog instead
 */
function ComposableModalHeader({ children, className }: Props) {
  return <div className={clsx('ComposableModalHeader', className)}>{children}</div>;
}

export default ComposableModalHeader;
